import { InjectionToken, inject } from '@angular/core';
import { AgentStore } from './agent.store';
import { IAgentStore } from './agent.public';

export const AGENT_STORE = new InjectionToken<IAgentStore>('AGENT_STORE', {
    providedIn: 'root',
    factory: () => inject(AgentStore) as IAgentStore,
});
